import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { getTableData } from "./getTableData";

import { CheckedIcon } from "../../components";
import { rowTitleStyles, rowValueStyles } from "./styles";

interface IProps {
  features: IPlanFeatureValue[];
  planFeatures: IPlanFeatureConfig[];
}

const Characteristics: React.FC<IProps> = ({ features, planFeatures }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width: 1023.98px)");
  const tableData = getTableData(features, planFeatures);

  return (
    <TableContainer>
      <Table size="small">
        <TableBody>
          {tableData.map(({ featureMasterID, title, value }) => (
            <TableRow key={featureMasterID}>
              <TableCell
                sx={{
                  ...rowTitleStyles,
                  padding: isMobile ? "8px 10px 8px 14px" : "8px 6px",
                }}
              >
                {title}
              </TableCell>

              {featureMasterID !== 1 ? (
                <TableCell
                  sx={{
                    padding: isMobile ? "8px 14px 8px 10px" : "8px 6px",
                    borderBottom: "none",
                    textAlign: "end",
                    color: theme.palette.grey[600],
                  }}
                >
                  <CheckedIcon checked={!!value} />
                </TableCell>
              ) : (
                <TableCell
                  sx={{
                    ...rowValueStyles,
                    padding: isMobile ? "8px 14px 8px 10px" : "8px 6px",
                  }}
                >
                  {value}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Characteristics;
